// WP50: an icon from the self-hosted sprite, for markup built in script. The sprite URL (with its version) is read from the page.
let sprite: string | null = null;

export function icon(name: string, cls = ""): SVGSVGElement {
  sprite ??= document.querySelector('use[href*="/icons/sprite.svg"]')?.getAttribute("href")?.split("#")[0] ?? "/icons/sprite.svg";
  const ns = "http://www.w3.org/2000/svg";
  const svg = document.createElementNS(ns, "svg");
  svg.setAttribute("class", cls ? `icon ${cls}` : "icon");
  svg.setAttribute("aria-hidden", "true");
  svg.setAttribute("focusable", "false");
  const use = document.createElementNS(ns, "use");
  use.setAttribute("href", `${sprite}#${name}`);
  svg.appendChild(use);
  return svg;
}
